'use client';

import type { FeatureIntroSectionData } from '../../types';
import { MediaAsset } from '../MediaAsset';
import { PortableTextContent } from '../PortableTextContent';
import { SectionShell } from '../section-shared';

export function FeatureIntroSection({ section }: { section: FeatureIntroSectionData }) {
  const media = section.media;
  const hasMedia =
    (media?.resourceType === 'image' && !!media.image?.url) || (media?.resourceType === 'video' && !!media.video?.url);

  return (
    <SectionShell>
      <div className="flex flex-col items-center gap-[72px] sm:gap-10">
        <div className="flex w-full flex-col items-center gap-6 text-center sm:gap-4">
          <div className="w-full">
            <h2 className="font-semibold text-[48px] text-white leading-none sm:text-[32px]">{section.title}</h2>
            <PortableTextContent className="mt-4 leading-[1.4]" value={section.description} />
          </div>
          {section.button?.href && section.button?.label && (
            <a
              className="inline-flex h-12 items-center justify-center rounded-full bg-[#0086FF] px-8 font-medium text-base text-white transition-colors hover:bg-[#0f91ff]"
              href={section.button.href}
              rel={/^https?:\/\//.test(section.button.href) ? 'noreferrer' : undefined}
              target={/^https?:\/\//.test(section.button.href) ? '_blank' : undefined}
            >
              {section.button.label}
            </a>
          )}
        </div>
        {hasMedia && (
          <div className="w-full overflow-hidden rounded-[24px] bg-[#e3e3e3] sm:rounded-[20px]">
            <MediaAsset className="aspect-video" media={media} />
          </div>
        )}
      </div>
    </SectionShell>
  );
}
